var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalInformacao",
      attrs: {
        titulo: "Solicitar Informação",
        width: _vm.width,
        isDespacho: true
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.showModalVisualizaPdf
            ? _c("app-modal-visualiza-pdf", {
                attrs: {
                  titulo: _vm.tituloModal,
                  tipo: _vm.tipoModal,
                  conteudo: _vm.conteudoModal,
                  isVTN: false,
                  isImagem: _vm.isImagem,
                  tituloDocumento: _vm.tituloDocumento
                },
                on: { closeModal: _vm.closeModalVisualizaPdf }
              })
            : _vm._e(),
          _vm._l(_vm.dados, function(dado, index) {
            return _c(
              "div",
              { key: dado.id, staticClass: "extra-margin-bottom" },
              [
                _c("div", { staticClass: "flex" }, [
                  _c("p", [
                    _c("b", [_vm._v("Solicitações: " + _vm._s(dado.assunto))])
                  ]),
                  _c("p", [
                    dado.status === "CANCELADA"
                      ? _c("b", { staticClass: "status" }, [
                          _vm._v("CANCELADA")
                        ])
                      : _vm._e()
                  ]),
                  dado.mensagemList.length === 1 &&
                  dado.status !== "RESPONDIDA" &&
                  dado.status !== "CANCELADA"
                    ? _c(
                        "a",
                        {
                          staticClass: "link",
                          on: {
                            click: function($event) {
                              return _vm.cancelarSolicitacao(dado.id)
                            }
                          }
                        },
                        [
                          _vm._v("Cancelar solicitação  "),
                          _c("i", { staticClass: "fa fa-times" })
                        ]
                      )
                    : _vm._e()
                ]),
                _c(
                  "el-collapse",
                  {
                    model: {
                      value: _vm.abaAtiva,
                      callback: function($$v) {
                        _vm.abaAtiva = $$v
                      },
                      expression: "abaAtiva"
                    }
                  },
                  _vm._l(dado.mensagemList, function(msg, index) {
                    return _c(
                      "el-collapse-item",
                      { key: msg.id },
                      [
                        _c("template", { slot: "title" }, [
                          _c("div", { staticClass: "flex title full-width" }, [
                            _c("span", [_vm._v(_vm._s(msg.nomeRemetente))]),
                            _c("span", { attrs: { type: "data" } }, [
                              _vm._v(_vm._s(msg.dataEnviada) + "  ")
                            ])
                          ])
                        ]),
                        _c("el-row", { staticClass: "margin-top" }, [
                          _c("p", [
                            _c("b", [_vm._v("Setor Origem:")]),
                            _c("span", [
                              _vm._v("  " + _vm._s(dado.setorOrigem))
                            ])
                          ]),
                          _c("p", [
                            _c("b", [_vm._v("Setor Requerido:")]),
                            _c("span", [
                              _vm._v("  " + _vm._s(dado.setorRequerido))
                            ])
                          ]),
                          _c("p", [
                            _c("b", [_vm._v("Responsável:")]),
                            _c("span", [
                              _vm._v("  " + _vm._s(dado.responsavel))
                            ])
                          ])
                        ]),
                        _c("el-row", { staticClass: "margin-top" }, [
                          _c("p", [
                            _c("b", [_vm._v("Data de Vencimento:")]),
                            _c("span", [
                              _vm._v(
                                "  " +
                                  _vm._s(_vm.removeNull(dado.dataVencimento))
                              )
                            ])
                          ])
                        ]),
                        _c("el-row", { staticClass: "margin-top" }, [
                          _c("p", [
                            _c("b", [
                              _vm._v(
                                _vm._s(index === 0 ? "Despacho:" : "Resposta:")
                              )
                            ])
                          ]),
                          _c("p", {
                            domProps: { innerHTML: _vm._s(msg.conteudo) }
                          })
                        ]),
                        _c(
                          "el-row",
                          { staticClass: "margin-top" },
                          [
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: dado.mensagemList[index].anexoList,
                                  stripe: "stripe"
                                }
                              },
                              [
                                _c("el-table-column", {
                                  staticClass: "td-column-anexo",
                                  attrs: { prop: "nome" }
                                }),
                                _c("el-table-column", {
                                  staticClass: "td-column-anexo",
                                  attrs: { align: "center", width: "85" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _vm.isEstadoAp
                                              ? _c("app-action-button", {
                                                  attrs: {
                                                    disabled: !_vm.isDocumentoParaVisualizacao(
                                                      scope.row
                                                    ),
                                                    cor: !_vm.isDocumentoParaVisualizacao(
                                                      scope.row
                                                    )
                                                      ? "#C0C4CC"
                                                      : "#666666",
                                                    text: !_vm.isDocumentoParaVisualizacao(
                                                      scope.row
                                                    )
                                                      ? "Não é possível exibir esse arquivo"
                                                      : "Visualizar",
                                                    icone: "eye",
                                                    fontSize: "18"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.abrirDocumento(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                })
                                              : _vm._e(),
                                            _c("app-action-button", {
                                              attrs: {
                                                icone: "download",
                                                nome: "file_download",
                                                hoverColor: "#009f61",
                                                text: "Baixar anexo"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.download(scope.row)
                                                }
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  }),
                  1
                )
              ],
              1
            )
          }),
          _c(
            "div",
            { staticClass: "extra-margin-top" },
            [
              _c(
                "validation-observer",
                { ref: "validation", attrs: { tag: "form" } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-label", {
                            attrs: { label: "Setor:", required: true }
                          }),
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "width90 input",
                                        class: { erro: errors.length },
                                        attrs: {
                                          clearable: "clearable",
                                          filterable: "filterable",
                                          placeholder: "Selecione",
                                          name: "setorEncaminhar"
                                        },
                                        on: {
                                          change: function(param) {
                                            return _vm.showInfoVencimento(param)
                                          }
                                        },
                                        model: {
                                          value: _vm.setorRequerido,
                                          callback: function($$v) {
                                            _vm.setorRequerido = $$v
                                          },
                                          expression: "setorRequerido"
                                        }
                                      },
                                      _vm._l(_vm.setores, function(setor) {
                                        return _c("el-option", {
                                          key: setor.id,
                                          attrs: {
                                            label: setor.codigo,
                                            value: setor.codigo
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    errors.length
                                      ? _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("app-label", {
                            attrs: {
                              label: "Data de vencimento:",
                              required: false
                            }
                          }),
                          _c("el-date-picker", {
                            staticClass: "input full-width",
                            attrs: {
                              placeholder: "Data de vencimento",
                              disabled: "disabled",
                              format: "dd/MM/yyyy",
                              type: "date",
                              required: false,
                              name: "prazo"
                            },
                            model: {
                              value: _vm.prazo,
                              callback: function($$v) {
                                _vm.prazo = $$v
                              },
                              expression: "prazo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "margin-top" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("app-label", {
                            staticClass: "mt-20",
                            attrs: { label: "Assunto:", required: true }
                          }),
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("el-input", {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { name: "assunto" },
                                      model: {
                                        value: _vm.assunto,
                                        callback: function($$v) {
                                          _vm.assunto = $$v
                                        },
                                        expression: "assunto"
                                      }
                                    }),
                                    errors.length
                                      ? _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "margin-top" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("app-label", {
                            staticClass: "mt-20",
                            attrs: { label: "Despacho:", required: true }
                          }),
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-editor-texto", {
                                      ref: "editorTexto",
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { value: _vm.mensagem },
                                      on: { onTextChange: _vm.onTextChange }
                                    }),
                                    errors.length
                                      ? _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-row", { staticClass: "margin-top" }, [
                    _c("p", { staticClass: "label mt-20" }, [
                      _vm._v("Anexos mensagem")
                    ])
                  ]),
                  _c(
                    "el-row",
                    { staticClass: "margin-top" },
                    [
                      _c("validation-provider", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-anexo", {
                                  attrs: {
                                    id: "upload-informacao-solicitar",
                                    files: _vm.anexos,
                                    scope: "anexos",
                                    errors: errors,
                                    exibirDownload: false
                                  },
                                  on: {
                                    removeFile: _vm.removeFile,
                                    uploadFile: _vm.uploadFile
                                  },
                                  model: {
                                    value: _vm.anexos,
                                    callback: function($$v) {
                                      _vm.anexos = $$v
                                    },
                                    expression: "anexos"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "default", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("b", [_vm._v("  Cancelar")])
                ])
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "success", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.sendMessage()
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-share-square" }),
                  _c("b", [_vm._v("  Enviar")])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18b99003", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b99003","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalInformacao.vue
// module id = null
// module chunks = 